<template>
  <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
    <div class='data-drid'>
      <dx-data-grid ref='refDiary'
        :data-source='planInfoList'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        :auto-navigate-to-focused-row="false"
        key-expr="품번"
        @toolbar-preparing='onToolbarPreparing'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          file-name="주간계획"
        />
        <DxEditing
          :allow-deleting="false"
          :allow-updating="false"
          :allow-adding="false"
          :use-icons="true"
          mode='batch'
        >
        </DxEditing>
        <DxColumnFixing :enabled="true"/>
        <DxColumn
          :allowEditing='false'
          :fixed="true"
          sort-order='asc'
          caption="품번"
          data-field="품번"
          width='100'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          :fixed="true"
          caption="품명"
          data-field="품명"
          width='120'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          :fixed="true"
          format ='#,##0'
          caption="합계"
          dataType="number"
          :calculateCellValue='sumPlan'
        >
        </DxColumn>
        <DxColumn
          caption="주간 생산계획"
          alignment='center'
        >
          <DxColumn v-for='(item, index)  in  dateArray' :key="index"
            :caption = item.caption
            :data-field = item.dataField
            :data-type = item.dataType
            :format = item.format
            :allow-sorting="false"
          />
        </DxColumn>
        <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            column="합계"
            summary-type="sum"
            display-format="{0}"
          />
          <DxTotalItem v-for='(item, index)  in  dateArray' :key="index+50"
            value-format='#,##0'
            :column = item.dataField
            summary-type="sum"
            display-format="{0}"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
      <div class='pivot-grid-wrap' style='margin-top:10px;'>
        <DxToolbar class='select-group'>
            <DxItem
              #default
              location="before"
              locate-in-menu="never"
            >
              <div class='toolbar-label' style='font-weight:bold;color:rgb(4, 103, 189);'>주간 구매품 소요량</div>
            </DxItem>
            <DxItem
              #default
              location="after"
              locate-in-menu="never"
            >
              <dx-check-box class='column-filtering'
                :value="isExpaneded"
                text="전항목 확장"
                @value-changed = "onExpandedAll"
              />
            </DxItem>
          </DxToolbar>
        <DxPivotGrid
          ref="summarySubPivot"
          :allow-sorting-by-summary="true"
          :allow-sorting="true"
          :allow-filtering="true"
          :allow-expand-all="true"
          :show-borders="true"
          :show-column-grand-totals="false"
          :show-row-grand-totals="false"
          :show-row-totals="true"
          :show-column-totals="false"
          :data-source="dataSource"
          :row-header-layout="rowHeaderLayout"
          :height='pivotHeight'
          @cell-prepared = 'onCellPrepared'
          @cell-click = 'onCellClick'
        >
          <DxFieldChooser
            :enabled="true"
            :height="400"
          />
          <DxExport
            :enabled="true"
            file-name="주간구매품소요량"
          />
        </DxPivotGrid>
      </div>
    </div>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>

  </div> <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxExport, DxColumnFixing, DxTotalItem, DxSummary,
  DxColumn, DxPaging, DxSorting, DxEditing, DxSearchPanel } from 'devextreme-vue/data-grid'
import axios from 'axios'
import { DxPivotGrid, DxFieldChooser } from 'devextreme-vue/pivot-grid'
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source'
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar'
import { DxCheckBox } from 'devextreme-vue'

export default {
  name: 'login',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      planInfoList: null,
      today: null,
      thisWeekendDate: null,
      nextWeekendDate: null,
      dateArray: null,
      // **** PIVOT ************
      dataSource: null,
      pivotDataSource: null,
      rowHeaderLayout: 'tree',
      pivotHeight: null,
      wipStockList: null,
      isExpaneded: true
    }
  },
  computed: {
  },
  components: {
    Loading,
    DxDataGrid,
    DxExport,
    DxColumnFixing,
    DxColumn,
    DxPaging,
    DxSorting,
    DxEditing,
    DxSearchPanel,
    DxSummary,
    DxTotalItem,
    DxScrolling,
    DxPivotGrid,
    DxFieldChooser,
    DxToolbar,
    DxItem,
    DxCheckBox
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    this.today = AppLib.getToday()
    this.productypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.calcNextWeekendDay(this.today)
    this.refreshWeekPlan()
  },
  mounted () {
    this.gridHeight = ((screen.height - 250) * 0.95) * 0.3
    this.pivotHeight = ((screen.height - 250) * 0.95) * 0.7
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    calcNextWeekendDay (day) {
      let week = AppLib.getWeekFromDateFormat(day)
      this.thisSundayDate = AppLib.calcDateFromToday(week * -1)
      this.weekDays = (7 - week) + 7
      this.thisWeekendDate = AppLib.calcDateFromToday(6 - week)
      this.nextWeekendDate = AppLib.calcDateFromToday((6 - week) + 7)
    },
    onCellClick (e) {
      if (e.area === 'column' && e.columnIndex === 0 && e.rowIndex === 0) { e.cancel = true }
    },
    onCellPrepared (e) {
      // console.log(e)
      let split = null
      let calcWip = false
      let where = null
      if (e.area === 'column' && e.columnIndex === 0 && e.rowIndex === 1) {
        this.$Q(e.cellElement).css({ background: 'rgb(255, 130, 128)' })
        this.$Q(e.cellElement).text('현재공')
      }
      if (e.area === 'data' && e.columnIndex === 0) {
        calcWip = false
        if (this.isExpaneded) {
          if (e.rowIndex % 2 === 0) {
            this.$Q(e.cellElement).text('0')
            calcWip = true
          } else {
            this.$Q(e.cellElement).text('')
          }
        } else {
          this.$Q(e.cellElement).text('0')
          calcWip = true
        }
        if (calcWip) {
          split = e.cell.rowPath[0].split('(')
          this.$Q(e.cellElement).css('color', 'red')
          where = this.$_.findWhere(this.wipStockList, { 품번: split[0] })
          this.$Q(e.cellElement).text(where.현재공)
        }
      }
    },
    initDateArray () {
      this.dateArray = []
      for (let j = 0; j < this.weekDays; j++) {
        let day = AppLib.calcDateFromFormat(this.today, j)
        day = `${day.substring(5, 7)}/${day.substring(8, 10)}`
        let dateTemp = {
          caption: day,
          dataField: day,
          format: '#,##0',
          dataType: 'number'
        }
        this.dateArray.push(dateTemp)
      }
    },
    makeWeekModel (planInfo, product) { // planInfo ={생산일자 품번 품명 수량}
      this.planInfoList = []
      this.initDateArray()
      if (planInfo === null) {
        for (let i = 0; i < product.length; i++) {
          let temp = {
            품번: product[i].품번,
            품명: product[i].품명
          }
          for (let j = 0; j < this.weekDays; j++) {
            temp.생산일자 = AppLib.calcDateFromFormat(this.today, j)
            let key = `${temp.생산일자.substring(5, 7)}/${temp.생산일자.substring(8, 10)}`
            temp[key] = null
          }
          this.planInfoList.push(temp)
        }
        return
      }
      for (let i = 0; i < product.length; i++) {
        let temp = {
          품번: product[i].품번,
          품명: product[i].품명
        }
        for (let j = 0; j < this.weekDays; j++) {
          temp.생산일자 = AppLib.calcDateFromFormat(this.today, j)
          let timeStamp = AppLib.getTimestampFromString(`${temp.생산일자} 00:00:00`)
          let key = `${temp.생산일자.substring(5, 7)}/${temp.생산일자.substring(8, 10)}`
          let where = this.$_.findWhere(planInfo, { 생산일자: timeStamp, 품번: product[i].품번 })
          if (where === undefined) {
            where = this.$_.findWhere(planInfo, { 생산일자: temp.생산일자, 품번: product[i].품번 })
          }
          if (where === undefined) {
            temp[key] = null
          } else {
            temp[key] = where.수량
          }
        }
        this.planInfoList.push(temp)
      }
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>주간 완제품 생산계획 </b></div>`
          }
        }
      )
    },
    refrshMrp (param) {
      const lineMrp = this.$_sp.runNoEncodeFindProc('spFindAllWeekProductLineMrpByDate', param)
      const wipStock = this.$_sp.runNoEncodeFindProc('spFindAllWipStockByToDateGByProductFromText', { toDate: AppLib.calcDateFromToday(1) })
      axios.all([lineMrp, wipStock])
        .then(axios.spread((...reponse) => {
          this.isLoading = false
          this.pivotDataSource = this.$_sp.MakeModel(reponse[0])
          this.wipStockList = this.$_sp.MakeModel(reponse[1])
          console.log(this.wipStockList)
          this.setInitPivotDataSource()
        }))
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    refreshWeekPlan () {
      let param = {
        sunday: this.thisSundayDate,
        fromDate: this.today,
        toDate: this.nextWeekendDate,
        goodsType: ConstDef.완제품
      }
      const thisWeek = this.$_sp.runNoEncodeFindProc('spFindAllWeekPlanned', param)
      const product = this.$_sp.runNoEncodeFindProc('spFindAllProductByType', { 품목유형: ConstDef.완제품 })
      this.isLoading = true
      axios.all([thisWeek, product])
        .then(axios.spread((...reponse) => {
          let thisWeek = this.$_sp.MakeModel(reponse[0])
          this.productInfo = this.$_sp.MakeModel(reponse[1])
          this.makeWeekModel(thisWeek, this.productInfo)
          if (thisWeek.length > 0) {
            this.refrshMrp(param)
          } else {
            this.isLoading = false
          }
        }))
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    setInitPivotDataSource () {
      this.dataSource = new PivotGridDataSource({
        fields: [
          {
            caption: 'Region',
            dataField: '품번명',
            area: 'row',
            width: '220'
          },
          {
            caption: '라인명',
            dataField: '라인명',
            area: 'row',
            width: '203'
          },
          {
            dataField: '소요일자',
            dataType: 'date',
            area: 'column',
            groupInterval: 'month',
            expanded: true
          },
          {
            dataField: '소요일자',
            dataType: 'date',
            area: 'column',
            groupInterval: 'day'
          },
          {
            caption: '소요량',
            dataField: '소요량',
            dataType: 'number',
            summaryType: 'sum',
            format: '#,##0',
            area: 'data'
          }

        ],
        store: this.pivotDataSource
      })
      setTimeout(() => {
        this.$refs.summarySubPivot.instance.getDataSource().expandAll('Region')
      }, 100)
    },
    sumPlan (e) {
      let sum = 0
      for (let i = 0; i < this.weekDays; i++) {
        let day = AppLib.calcDateFromFormat(this.today, i)
        let key = `${day.substring(5, 7)}/${day.substring(8, 10)}`
        sum += e[key]
      }
      return sum
    },
    // ********* 피봇그리드 ****************
    onClickToPdf (e) {
    },
    onExpandedAll (e) {
      this.isExpaneded = e.value
      if (e.value) {
        this.$refs.summarySubPivot.instance.getDataSource().expandAll('Region')
      } else {
        this.$refs.summarySubPivot.instance.getDataSource().collapseAll('Region')
      }
    }
  }
}
</script>

<style lang="scss">

</style>
